import ValueChain from "../ValueChain";

interface StringInputProps {
  label: string;
  textValue: string | null;
  onChange: (e: any) => void;
  maxLength : number;
  isValid : boolean;
}

function StringInput({
  label,
  textValue,
  onChange,
  maxLength,
  isValid
}: StringInputProps) {
  return (
      <div className="form-group">
        <label className="control-label">{label}</label>
        <div className="text-area-noconfidential-container">
            <input
              type ="text"
              className={isValid ? "form-control" : "form-control is-invalid"}
              value={textValue ?? ''}
              onChange={onChange}
              maxLength={maxLength}/>
          
        </div>
      </div>
  );
}

export default StringInput;
